module.exports = __webpack_public_path__ + "img/img25.8c40a619.svg";